import { CompoundFilterStateModifiers } from '../../CompoundFilter.types';

/**
 * The purpose of this helper function is to accurately determine
 * the correct state by resolving any state modifiers. It is designed
 * to handle situations where state modifiers may be undefined.
 */
export const resolveCompoundFilterStateModifiers = (
  stateOptions?: CompoundFilterStateModifiers,
): Required<CompoundFilterStateModifiers> => {
  const resolvedStateOptions: Required<CompoundFilterStateModifiers> = {
    isActive: stateOptions?.isActive ?? false,
    isClearable: stateOptions?.isClearable ?? true,
    isVisible: stateOptions?.isVisible ?? true,
    isRemovable: stateOptions?.isRemovable ?? true,
    isToggleable: stateOptions?.isToggleable ?? true,
  };

  return resolvedStateOptions;
};
